import { Toggle } from '@fluentui/react';

import { actions, useFormSelector } from '../../../slice';
import { FormVariables } from '../../../slice/newFormReducers';

export default () => {
  const value = useFormSelector(selector);

  return <Toggle label="Özel Sipariş" checked={!!value} onChange={onChange} />;
};

const selector = (state: FormVariables) => state.isSpecialOrder;
const onChange = (_?: any, newValue?: boolean) =>
  actions.setFormVariable(["isSpecialOrder", !!newValue]);
